
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";

@Component
export default class Header extends Vue {
  @State ("displaying", { namespace: 'MuseumModule' }) private displaying!: string;

  private aboutIsActive(){
    const routeName = this.$route.name;
    if(routeName=="Projects" || routeName=="CV"){
      return true;
    }else{
      return false;
    }
  }

  private contactIsActive(){
    const routeName = this.$route.name;
    if(routeName=="Contact"){
      return true;
    }else{
      return false;
    }
  }

  private isDark(){
    //if(this.$route.name=="CV"){
    return true;
  }

  private colorScalesIsActive(){
    const routeName = this.$route.name;
    if(routeName=="Studio" || routeName=="Artists" || routeName=="Artist" || routeName=="History" || routeName=="Scales"){
      return true;
    }else{
      return false;
    }
  }
}

